import {useSelector} from "react-redux";

export const useProfile = () => {
	return useSelector((state) => {
		return state.profile?.data || [];
	});
}